import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateEntityCustomShippingFeeCodeQuery,
  EntityCustomShippingFeeQuery,
  EntityCustomShippingFeesApi,
} from 'api';

import { entityCustomShippingFeeQuery } from '../containers/Branding/Farm/Setting/commons/query';

export const createEntityCustomShippingFee = createAsyncThunk(
  'entityCustomShippingFee/createEntityCustomShippingFee',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCustomShippingFeesApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateEntityCustomShippingFeeCode = createAsyncThunk(
  'entityCustomShippingFee/checkDuplicateEntityCustomShippingFeeCode',
  async (
    query: CheckDuplicateEntityCustomShippingFeeCodeQuery,
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityCustomShippingFeesApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityCustomShippingFee = createAsyncThunk(
  'entityCustomShippingFee/findEntityCustomShippingFee',
  async (option: EntityCustomShippingFeeQuery, { rejectWithValue }) => {
    try {
      const response = await EntityCustomShippingFeesApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityCustomShippingFee = createAsyncThunk(
  'entityCustomShippingFee/updateEntityCustomShippingFee',
  async (
    {
      id,
      body,
    }: {
      id: string;
      body: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityCustomShippingFeesApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityCustomShippingFee = createAsyncThunk(
  'entityCustomShippingFee/removeEntityCustomShippingFee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityCustomShippingFeesApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  tableList: [],
  list: [],
  reloadFlag: false,
  query: entityCustomShippingFeeQuery,
};

const entityCustomShippingFeeSlice = createSlice({
  name: 'entityCustomShippingFee',
  initialState,
  reducers: {
    reloadEntityCustomShippingFee(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityCustomShippingFee.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.tableList = data;
    });
  },
});

const { actions, reducer: entityCustomShippingFeeReducer } =
  entityCustomShippingFeeSlice;

export const { reloadEntityCustomShippingFee } = actions;

export default entityCustomShippingFeeReducer;
